import { IconProps } from "@/common/contracts/icon.contracts";

export const ArBox = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1362_306)">
        <path
          d="M17 22V20H20V17H22V20.5C22 20.89 21.84 21.24 21.54 21.54C21.24 21.84 20.89 22 20.5 22H17ZM7 22H3.5C3.11 22 2.76 21.84 2.46 21.54C2.16 21.24 2 20.89 2 20.5V17H4V20H7V22ZM17 2H20.5C20.89 2 21.24 2.16 21.54 2.46C21.84 2.76 22 3.11 22 3.5V7H20V4H17V2ZM7 2V4H4V7H2V3.5C2 3.11 2.16 2.76 2.46 2.46C2.76 2.16 3.11 2 3.5 2H7ZM13 17.25L17 14.95V10.36L13 12.66V17.25ZM12 10.92L16 8.63L12 6.28L8 8.63L12 10.92ZM7 14.95L11 17.25V12.66L7 10.36V14.95ZM18.23 7.59C18.73 7.91 19 8.34 19 8.91V15.23C19 15.8 18.73 16.23 18.23 16.55L12.75 19.73C12.25 20.05 11.75 20.05 11.25 19.73L5.77 16.55C5.27 16.23 5 15.8 5 15.23V8.91C5 8.34 5.27 7.91 5.77 7.59L11.25 4.41C11.5 4.28 11.75 4.22 12 4.22C12.25 4.22 12.5 4.28 12.75 4.41L18.23 7.59Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1362_306">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
